import { H5 } from 'foundations-components/transitional/components/H5';
import ErrorsCountBanner from '../common/ErrorsCountBanner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import { useStrategy } from '../../hooks/useStrategy';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import TestFilters from './TestFilters';
import ViewerEditButton from './ViewerEditButton';
import ViewerTestFiltersButton from './ViewerTestFiltersButton';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerHeader = () => {
  const {
    isInEditMode,
    isInTestFilters,
    props: {
      additionalHeaderButtons,
      uiMessages,
      isReadOnly
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    isTestFiltersEnabled
  } = useStrategy();
  if (isReadOnly && !uiMessages.filtersHeaderLabel) {
    return /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "400",
      as: "div"
    });
  }
  return /*#__PURE__*/_jsxs(FoundationsView, {
    padding: "400",
    as: "div",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      minBlockSize: "26px",
      children: [/*#__PURE__*/_jsx(H5, {
        margin: "0",
        children: uiMessages && uiMessages.filtersHeaderLabel ? uiMessages.filtersHeaderLabel : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.viewerPanelHeader"
        })
      }), /*#__PURE__*/_jsxs(ButtonWrapper, {
        justify: "end",
        children: [additionalHeaderButtons, isTestFiltersEnabled && /*#__PURE__*/_jsx(ViewerTestFiltersButton, {}), /*#__PURE__*/_jsx(ViewerEditButton, {})]
      })]
    }), isTestFiltersEnabled && isInTestFilters && /*#__PURE__*/_jsx(TestFilters, {}), isInEditMode && /*#__PURE__*/_jsx(ErrorsCountBanner, {})]
  });
};
export default ViewerHeader;